import React from 'react';

export default function NoData() {
  return (
    <div className="py-5 border-bottom w-100 text-center">
      <h2>No results found</h2>
      <p>
        We couldn&apos;t find any matches for your search.
        Try adjusting your filters or search terms.
      </p>
    </div>
  );
}
